import { z } from '@framework/zod';

interface IRangeValues {
  min: string,
  max: string,
}

type TRangeRefine = (values: IRangeValues, ctx: z.RefinementCtx) => void;

const toNum = (val: string): number | null => (val === '' ? null : Number(val));

const withinBounds = (min?: number, max?: number): TRangeRefine => (values, ctx) => {
  const checkField = (field: keyof IRangeValues): void => {
    const val = toNum(values[field]);
    if (val === null) return;

    if (min != null && val < min) {
      ctx.addIssue({ code: 'custom', message: `Value must be ${ min } or greater`, path: [field] });
    }
    if (max != null && val > max) {
      ctx.addIssue({ code: 'custom', message: `Value must be ${ max } or less`, path: [field] });
    }
  };

  checkField('min');
  checkField('max');
};

const minLessThanMax: TRangeRefine = ({ min, max }, ctx) => {
  const minVal = toNum(min);
  const maxVal = toNum(max);
  if (minVal !== null && maxVal !== null && minVal > maxVal) {
    ctx.addIssue({ code: 'custom', message: 'Min value must be less than Max', path: ['min'] });
  }
};

export { withinBounds, minLessThanMax };
export type { TRangeRefine, IRangeValues };
